module.exports = __webpack_public_path__ + "img/logo.65a8fb34.svg";